/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.requests.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.common.service.themesHelper',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.resources.modals.assign.controllers',
  'acme.view.application.reports.create.showMessageModal.controllers',
  'acme.common.service.userPreferences'
])

.controller('ResourcesRequestsController', ['$scope', '$state', '$controller', '$filter', '$timeout', '$uibModal', 'ApiService', 'HelpersService', 'CalendarService', 'GridStateFactory', 'GridDefinitionFactory', 'PermissionsService', 'customFields', 'ThemesHelperService', 'UserPreferencesService', function($scope, $state, $controller, $filter, $timeout, $uibModal, ApiService, HelpersService, CalendarService, GridStateFactory, GridDefinitionFactory, PermissionsService, customFields, ThemesHelperService, UserPreferencesService) {

    $scope.resourcesRequests = {

      model: [],
      customFields: customFields.data.payload.list || [],

      searchQuery: '',
      lastTemplateQuery: '',
      queryTimer: false,
      templateSearchTimer: false,
      isLoaded: false,
      categories: [
        {
          label: 'Place',
          type: 'facility'
        },
        {
          label: 'Person',
          type: 'person'
        },
        {
          label: 'Equipment',
          type: 'equipment'
        }],

      emailSetting: 'always',
      company: ThemesHelperService.getCompany(),

      eventTemplates: [],
      selectedEventTemplate: '',
      showModal: {},
      showRemoveModal: {},
      showMessageModal: {},

      fromDate: new Date(),
      toDate: new Date(),

      dateError: '',
      requestListGridName: $state.current.name + '.grid0',
      gridDefinition: new GridDefinitionFactory(),
      gridState: new GridStateFactory(),
      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      templateGridState: new GridStateFactory(),
      templateGridStatePageSize: 5,

      optionsOverride: {
        useAccessibleGrid: true,
        data: 'resourcesRequests.model',
        rowHeight: 60,
        exporterPdfHeader: {
            columns: [
            {
              text: 'Resource Assignments',
              alignment: 'center',
              margin: 10,
              bold: true,
              fillColor: 'red'
            }
          ]
        },
        exporterFieldCallback: function ( grid, row, col, value ){
          if ( col.field === 'assigned' ){

          }
          switch (col.field) {
            case 'assigned':  value = row.entity.resourceName || '';
                              break;
            case 'eventScheduleName': value = row.entity.eventScheduleDisplayName || '';
                              break;
            case 'eventStartTime': value = row.entity.eventTimeSlot || '';
                              break;
            case 'resourceStartTime': value = row.entity.timeSlot || '';
                              break;
            case 'resourceTemplateName': value = row.entity.requestFor || '';
                              break;

          }
          return value;
        },
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.resourcesRequests.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.resourcesRequests.onDataGridSortChange(grid, columns);
          },
          onDblClick: function (row) {
            $scope.resourcesRequests.gridDoubleClick(row);
          },
          onEventClick: function (item) {
            $state.go('application.programsInstance', { id: item.eventId });
          },
          onResourceTemplateClick: function(item) {
            $state.go('application.entities.templates.edit', { type: item.resourceCategory.toLowerCase(), id: item.resourceTemplateId });
          },
          remove: function (item) {
            $scope.resourcesRequests.remove(item);
          },
          assign: function (item) {
            $scope.resourcesRequests.assign(item);
          },
          selfAssign: function (item) {
            $scope.resourcesRequests.assign(item);
          },
          validate: function (permission) {
            return $scope.resourcesRequests.validate(permission);
          },
          isSelfAssign: function (row) {
            return (!row.entity.resourceId);
          },
          isAssignable: function (row, grid) {
            return (row.entity.resourceId && grid.appScope.validate('RESOURCES_REQUESTS_ASSIGN'));
          }
        },
        columnDefs: [
          {
            field: 'eventScheduleName',
            displayName: 'Event - Schedule',
            onCellNavClick: function(row, col) {
              $scope.resourcesRequests.optionsOverride.appScopeProvider.onEventClick(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onEventClick(row.entity)">{{ row.entity.eventScheduleDisplayName }}</a></div>',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'organizationName',
            displayName: 'Organization Name'
          },
          {
            field: 'eventStartTime',
            displayName: 'Event Time',
            width: 140,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.eventTimeSlot }}</div>'
          },
          {
            field: 'resourceStartTime',
            displayName: 'Request Time',
            width: 140,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.timeSlot }}</div>',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'resourceTemplateName',
            displayName: 'Request For',
            onCellNavClick: function(row, col) {
              $scope.resourcesRequests.optionsOverride.appScopeProvider.onResourceTemplateClick(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onResourceTemplateClick(row.entity)">{{ row.entity.requestFor }}</a></div>'
          },
          {
            field: 'resourceName',
            displayName: 'Assigned To',
            width: 160,
            onCellNavClick: function(row, col) {
              $scope.resourcesRequests.optionsOverride.appScopeProvider.assign(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-hide="grid.appScope.isAssignable(row, grid)"> {{ row.entity.resourceName }}</span> <a role="button" data-ng-click="grid.appScope.assign(row.entity)" data-ng-show="grid.appScope.isAssignable(row, grid)">{{ row.entity.resourceName }} <span class="sr-only"> - opens dialog</span></a><div class="text-center"><a role="button" class="btn btn-info btn-sm resources-requests-grid-btn" data-ng-click="grid.appScope.assign(row.entity)" data-ng-show="grid.appScope.isSelfAssign(row)">{{ row.entity.assignLabel }}<span class="sr-only"> - opens dialog</span></a></div></div>'
          },
          {
            field: 'notes',
            displayName: 'Notes'
          }
        ]
      },

      init: function() {
        var self = $scope.resourcesRequests,
            startDate,
            endDate;
        this.viewId = $state.current.name;

        $scope.$emit('Application::contentTitleChange', {
          title: 'Resource Assignments'
        });


        if (PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.resourcesRequests.optionsOverride.appScopeProvider.remove(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<a data-ng-if="row.entity.resourceRequestType !== \'scheduleBased\'" data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only"> - opens dialog</span></a>' +
                            '<a data-ng-if="row.entity.resourceRequestType === \'scheduleBased\'" data-ng-click="grid.appScope.remove(row.entity)" role="link"><span class="fa fa-info-circle" title="To remove, go to the Schedule in the event template."></span><span data-permit="[\'EVENT_TEMPLATE_UPDATE\', \'RESOURCES_REQUESTS_DELETE\']"> Remove</span></a>' +
            '</div>',
            enableHiding: false,
            enableSorting: false
          });
        }

        if(angular.isArray(self.customFields) && self.customFields.length) {
          var idxPosition = 3;
          self.customFields.forEach(function (customFieldItem, idx) {
            self.optionsOverride.columnDefs.splice(idxPosition, 0,{
              field: customFieldItem.internalLabel,
              displayName: customFieldItem.label,
              visible: false,
              colId: customFieldItem.label
            });
            idxPosition += 1;
          });
        }
        
        this.gridDefinition.init(this.requestListGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

        this.toDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), (this.fromDate.getDate()+7));

        if ($state.params.search) {
          self.searchQuery = $state.params.search;
          if ($state.params.resourceStartTime) {
            startDate = CalendarService.parseDate($state.params.resourceStartTime);
            if ($state.params.resourceEndTime) {
              endDate = CalendarService.parseDate($state.params.resourceEndTime);
            }else{
              endDate = new Date(startDate.getFullYear(), startDate.getMonth(), (startDate.getDate()+7));
            }
          }
          if (startDate instanceof Date &&
              !isNaN(startDate.valueOf()) &&
              endDate instanceof Date &&
              !isNaN(endDate.valueOf()) &&
              (startDate.getTime() < endDate.getTime())) {
            this.fromDate = startDate;
            this.toDate = endDate;
          }
          this.query();
        }else {
          this.getEventTemplates(false);
        }

        this.getNotificationPreference();
        
        $scope.$on('ResourcesModalsAssignController::error', this.onResourcesModalsAssignControllerError);

        $scope.$on('$destroy', $scope.$watch('resourcesRequests.toDate', this.onFormElementUpdate));
        $scope.$on('$destroy', $scope.$watch('resourcesRequests.fromDate', this.onFormElementUpdate));
        $scope.$on('$destroy', $scope.$watch('resourcesRequests.selectedEventTemplate', this.onFormElementUpdate));

      },

      initData: function() {
        var self = $scope.resourcesRequests, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getRequests();
      },

      getNotificationPreference: function() {
        if (this.company.hasOwnProperty('notificationPreference')) {
          this.emailSetting = this.company.notificationPreference;
        }
      },

      getRequests: function() {
        var props = angular.copy(this.gridState.getGridState());

        this.isLoaded = false;
        this.gridDefinition.isLoaded = false;

        if (this.selectedEventTemplate && this.selectedEventTemplate.id) {
          props.eventTemplateId = this.selectedEventTemplate.id;
        }
        if (this.fromDate && this.toDate) {
          props.resourceStartTime = CalendarService.toISO8601(this.fromDate);
          this.toDate.setHours(23);
          this.toDate.setMinutes(59);
          this.toDate.setSeconds(59);
          props.resourceEndTime = CalendarService.toISO8601(this.toDate);
        }
        if (this.isValidDateRange()) {
          this.dateError = '';
          ApiService.resource.requests.list(props).then(this.success.getRequests, this.error.getRequests);
        } else {
          this.isLoaded = true;
          this.gridDefinition.isLoaded = true;

          this.dateError = 'Please enter a valid date range.';
        }
      },

      query: function() {
        var self = $scope.resourcesRequests;
        self.gridState.setPropertyValue('search', self.searchQuery);
        self.getRequests();
      },

      getEventTemplates: function(field) {
        this.searching = true;
        ApiService.program.list(false, this.templateGridState.getGridState()).then(function(response) {
          $scope.resourcesRequests.success.getEventTemplates(response, field);
        }, this.error.getEventTemplates);
      },

      hasCategories: function() {
        return $scope.resourcesRequests.categories && $scope.resourcesRequests.categories.length;
      },

      hasEventTemplates: function() {
        return $scope.resourcesRequests.eventTemplates && $scope.resourcesRequests.eventTemplates.length;
      },

      hasSelectedEventTemplate: function() {
        return (this.selectedEventTemplate && typeof this.selectedEventTemplate === 'object');
      },

      resetSelected: function() {
        var self = $scope.resourcesRequests;
        $timeout(function() {
          //reset template selected if no template is chosen
          if (!self.hasSelectedEventTemplate()) {
            if (self.currentTemplate) {
              self.selectedEventTemplate = self.currentTemplate;
            } else {
              self.selectedEventTemplate = '';
            }
          }
        },0);
      },

      filterList: function(force, field) {
        var timeoutMS = force ? 0 : 500;

        if (this.templateSearchTimer) {
          $timeout.cancel(this.templateSearchTimer);
        }

        this.templateSearchTimer = $timeout(function () {
          var self = $scope.resourcesRequests;

          if (force || (typeof self.selectedEventTemplate === 'string') && (self.lastTemplateQuery !== self.selectedEventTemplate)) {
            if (!force) {
              self.templateGridState.setPropertyValue('pageSize', self.templateGridStatePageSize);
              self.currentTemplate = self.selectedEventTemplate;
            } else {
              self.templateGridState.setPropertyValue('pageSize', (self.templateGridState.gridState.pageSize + self.templateGridStatePageSize) );
            }
            self.templateGridState.gridState.search = self.hasSelectedEventTemplate() ? '' : self.selectedEventTemplate;
            self.lastTemplateQuery = self.templateGridState.gridState.search;
            self.getEventTemplates(field);
          }
        }, timeoutMS);
      },

      isValidDateRange: function() {
        var self = $scope.resourcesRequests;
        return (self.toDate && self.fromDate && (new Date(self.toDate).getTime() - new Date(self.fromDate).getTime()) > -1);
      },

      process: function(events, count) {
        var r = events,
          currentCount = (this.templateGridState.gridState.page || 1) * this.templateGridState.gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMore = {
            showMoreLabel: 'Show '+ this.templateGridStatePageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this.showMore = {
            showMoreLabel: '',
            hasMore: false
          };
        }
        return r;
      },

      showMoreResults: function(item) {
        switch(item.field) {
          case 'resources-requests-event-templates-list': this.filterList(true, item.field);
            break;
        }
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      findResourceRequest: function(id) {
        var i, ii, r = false;
        for (i = 0, ii = this.model.length; i < ii; i++) {
          if (this.model[i].id === id) {
            r = {
              index: i,
              item: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      processResourceRequests: function(requests) {
        var i, ii,
            evStartTime,
            evEndTime,
            reqStartTime,
            reqEndTime,
            j, jj;

        for (i = 0, ii = requests.length; i < ii; i++) {
          reqStartTime = CalendarService.parseDate(requests[i].resourceStartTime);
          reqEndTime = CalendarService.parseDate(requests[i].resourceEndTime);
          evStartTime = CalendarService.parseDate(requests[i].eventStartTime);
          evEndTime = CalendarService.parseDate(requests[i].eventEndTime);
          requests[i].timeSlot =  this.getDateRange(reqStartTime, reqEndTime);
          requests[i].eventTimeSlot =  this.getDateRange(evStartTime, evEndTime);
          requests[i].assignLabel = 'Assign';

          if (requests[i].resourceCategory === 'Personnel' &&
              !PermissionsService.check(['RESOURCES_REQUESTS_ASSIGN']) &&
              PermissionsService.check(['RESOURCES_REQUESTS_SELF_ASSIGN'])) {
            requests[i].assignLabel = 'Assign to me';
          }

          if (!requests[i].values.length) {
            requests[i].requestFor = requests[i].resourceTemplateName;
          }else if (requests[i].values.length < 3) {
            requests[i].requestFor = requests[i].resourceTemplateName + ': ' + requests[i].values.join(', ');
          }else{
            requests[i].requestFor = requests[i].resourceTemplateName + ': ' + requests[i].values.slice(0, 3).join(', ') + ', ' + '+ more';
          }

          requests[i].eventScheduleDisplayName = requests[i].eventName + (requests[i].eventScheduleName ? (' - ' + requests[i].eventScheduleName) : '');

          for (j=0, jj=this.customFields.length; j < jj; j++) {
            requests[i][this.customFields[j].internalLabel] = HelpersService.getCustomFieldValue(requests[i], this.customFields[j].label);
          }
        }

        return requests;
      },

      selfAssign: function(request) {
        // Instantiate controller with new $scope
        var ResourcesModalsAssignViewModel = $scope.$new(),
            ResourcesModalsAssignController = $controller('ResourcesModalsAssignController', {
              $scope : ResourcesModalsAssignViewModel,
              $uibModalInstance: {
                close: function(request) {
                  $scope.resourcesRequests.completeAssign(request);
                },
                dismiss: function() {}
              },
              request: request,
              emailSetting: $scope.resourcesRequests.emailSetting
            });

        ResourcesModalsAssignViewModel.resourcesModalsAssign.assignToSelf();
        // Destroy the scope and thereby the controller as well
        ResourcesModalsAssignViewModel.$destroy();
      },

      getDateRange: function(start, end) {
        var r = $filter('date')(CalendarService.parseDate(start), this.dateTimeFormat);

        if (end) {
          r += ' - ';
          r += $filter('date')(CalendarService.parseDate(end), this.dateTimeFormat);
        }else{
          r += ' - ';
          r += 'Indefinite';
        }

        return r;
      },

      gridDoubleClick: function(row) {
        if(row.entity.resourceId && $scope.resourcesRequests.validate('RESOURCES_REQUESTS_ASSIGN')) {
          $scope.resourcesRequests.assign(row.entity);
        }
      },

      remove: function(item) {
        var self = $scope.resourcesRequests;
        if (item && (item.resourceRequestType === 'scheduleBased')) {
          if (PermissionsService.check('EVENT_TEMPLATE_UPDATE') && PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
            $state.go('application.templates.edit.schedules.edit.resources', ({ id: item.eventTemplateId, scheduleId: item.eventScheduleId}));
          }
        } else if (PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
          self.showRemoveModal = $uibModal.open({
            templateUrl: 'views/application/views/resources/requests/modals/remove.tpl.html',
            size: 'md',
            controller: 'ResourcesRequestsRemoveModalController',
            resolve: {
              resourceRequest: function () {
                return angular.extend(item, {
                  request: {
                    resourceCategory: item.resourceCategory,
                    resourceName: item.resourceName
                  }
                });
              },
              emailSetting: function () {
                return self.emailSetting;
              },
              showEmailNotification: function() {
                return true;
              }
            }
          });

          self.showRemoveModal.result.then(function (sendEmail) {
              var self = $scope.resourcesRequests,
                found = self.findResourceRequest(item.id);
              if (found) {
                self.model.splice(found.index, 1);
              }
              ApiService.program.resources.instance.remove({
                id: item.eventId,
                requestId: item.eventInstanceResourceRequestId,
                sendEmail: sendEmail
              }).then(self.success.remove, self.error.remove);
            },
            function () {
              //do nothing;
            });
        }
      },

      assign: function(item) {

        if (PermissionsService.check(['RESOURCES_REQUESTS_ASSIGN', 'RESOURCES_REQUESTS_SELF_ASSIGN'])) {

          if (item.resourceCategory === 'Personnel' &&
              !PermissionsService.check('RESOURCES_REQUESTS_ASSIGN')) {
            // Self assign only permission
            if (!item.resourceId) {
              this.selfAssign(item);
            }else{
              this.showAssignModal(item);
            }
          }else if (PermissionsService.check('RESOURCES_REQUESTS_ASSIGN')) {
            this.showAssignModal(item);
          }else{
            $scope.$emit('Permissions::error');
          }
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      showAssignModal: function(request) {
        var self = $scope.resourcesRequests;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsAssignController',
          resolve: {
            request: function () {
              return request;
            },
            emailSetting: function () {
              return self.emailSetting;
            }
          }
        });

        self.showModal.result.then(function (request) {
          self.completeAssign(request);
        }, function () {
        });
      },

      showMessage: function(title, message) {
        var self = $scope.resourcesRequests;

        if (message) {
          self.showMessageModal = $uibModal.open({
            templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
            size: 'md',
            controller: 'ReportsCreateShowMessageModalController',
            resolve: {
              currentTitle: function () {
                return title;
              },
              currentMessage: function () {
                return message;
              },
              safe: function() {
                return true;
              }
            }
          });
          // Invoked when modal completes with close(params)
          self.showMessageModal.result.then(function () {
          }, function () {
            // Do nothing
          });
        }
      },

      completeAssign: function(request) {
        var found;

        request = this.processResourceRequests([request])[0];

        if (request && request.id) {
          found = this.findResourceRequest(request.id);

          if (found) {
            this.model[found.index] = request;
          } else {
            this.model.push(request);
          }
        } else {
          this.model.push(request);
        }

      },
      
      validate: function (permission) {
        return PermissionsService.check(permission);
      },

      success: {
        getRequests: function(response) {
          var self = $scope.resourcesRequests;
          self.model = self.processResourceRequests(response.data.payload.list);
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
          self.isLoaded = true;
        },

        getEventTemplates: function(response, field) {
          var self = $scope.resourcesRequests;
          self.eventTemplates = self.process(response.data.payload.list, response.data.payload.pagination.count);
          self.searching = false;

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }
        },

        remove: function(response) {
          //remove from requests list;
        }
      },

      error: {
        getRequests: function(response) {
          var self = $scope.resourcesRequests;
          self.isLoaded = true;
        },
        getEventTemplates: function(response) {
          $scope.resourcesRequests.searching = false;
        },
        remove: function(response) {

        }
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.resourcesRequests;

        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getRequests();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.resourcesRequests,
            data = columns[0];

          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getRequests();
      },

      onResourcesModalsAssignControllerError: function (e, data) {
        $scope.resourcesRequests.showMessage('An error has occurred', data.message);
      },

      onFormElementUpdate: function(n, o ) {
        if (n !== o) {
          $scope.resourcesRequests.query();
        }
      }

    };

    $scope.resourcesRequests.init();

}])
  .controller('ResourcesRequestsDatePickerController', ['$scope', '$timeout', 'UserPreferencesService', function($scope, $timeout, UserPreferencesService) {
    $scope.resourcesRequestsDatePicker = {

      isOpen: false,
      isPreferenceLoaded: false,
      dateOptions: {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
        showWeeks: false
      },
      
      dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      init: function() {
        this.today();
        $scope.initDate = new Date('2016-15-20');
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
        $scope.format = $scope.formats[1];
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
        $timeout(function () {
            $scope.resourcesRequestsDatePicker.isPreferenceLoaded = true;
        },100);
      },

      today: function() {
        this.dt = new Date();
      },

      clear: function () {
        $scope.dt = null;
      },

      toggleMin: function() {
        $scope.minDate = $scope.minDate ? null : new Date();
      },

      open: function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        this.isOpen = true;
      },
      
      onDateFormatLoad: function (e, data) {

        var self = $scope.resourcesRequestsDatePicker;

        self.dateOptions.startingDay = UserPreferencesService.getStartDayOfWeek();
        self.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
        self.dateOptions = {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
        };
      
      }

    };
    
    $scope.resourcesRequestsDatePicker.init();

  }])
  .filter('UTCDate', ['CalendarService', 'dateFilter', function(CalendarService, dateFilter) {
    return function(input, format) {
      console.log('ReportsCreateController::input', input);
      return input ? dateFilter(CalendarService.parseDate(input), format) : '';
    };
  }]);